// TourContext.js
import axios from 'utils/axios';
import { USER } from 'constants/api';
import PropTypes from 'prop-types';
import React, { createContext, useContext, useState } from 'react';
import useAuth from 'hooks/useAuth';

const TourContext = createContext();
export const useTour = () => useContext(TourContext);

const TourProvider = ({ children }) => {
    const [isRunning, setIsRunning] = useState(false);
    const [stepIndex, setStepIndex] = useState(0);
    const [steps, setSteps] = useState([]);
    const { refetchSession } = useAuth();

    const startTour = (newSteps) => {
        console.log('Starting tour with steps:', newSteps);
        setSteps(newSteps);
        setStepIndex(0);
        setIsRunning(true);
        console.log('Tour started, isRunning:', true);
    };

    const stopTour = () => {
        console.log('Stopping tour');
        setIsRunning(false);
        setStepIndex(0);
        setSteps([]);
    };

    const updateTour = async (tourName, isCompleted) => {
        await axios.post(`${USER.v1.updateTour}/${tourName}`, {
            completed: isCompleted
        });
        await refetchSession();
    };

    return (
        <TourContext.Provider
            value={{
                isRunning,
                stepIndex,
                steps,
                setStepIndex,
                startTour,
                stopTour,
                updateTour
            }}
        >
            {children}
        </TourContext.Provider>
    );
};

TourProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default TourProvider;
